import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { esqueciSenha } from '../services/usuarios';
import './PortalCliente.css';

function PortalEsqueciSenha() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('submitting');
    setMessage('');

    try {
      await esqueciSenha({ email: email.trim() });
      navigate('/portal/resetar-senha', { state: { email: email.trim() } });
    } catch (err) {
      setStatus('error');
      setMessage(err.message || 'Não foi possível solicitar a recuperação. Tente novamente.');
    }
  };

  return (
    <div className="portal-page">
      <div className="page-hero">
        <h1>Esqueci a senha</h1>
        <p>Informe seu e-mail para receber o token de recuperação.</p>
      </div>

      <section className="section">
        <div className="container">
          <div className="portal-login-box">
            <h2>Recuperar senha</h2>
            <p className="portal-subtitle">Digite o e-mail cadastrado no portal.</p>

            <form className="portal-login-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="esqueci-email">E-mail</label>
                <input
                  type="email"
                  id="esqueci-email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  autoComplete="email"
                  placeholder="seu@email.com"
                  disabled={status === 'submitting'}
                />
              </div>

              {status === 'error' && (
                <p className="form-error" role="alert">{message}</p>
              )}

              <button type="submit" className="btn btn-primary btn-large" disabled={status === 'submitting'}>
                {status === 'submitting' ? 'Enviando...' : 'Enviar'}
              </button>
            </form>

            <p className="portal-switch">
              Lembrou a senha?{' '}
              <Link to="/portal">Fazer login</Link>
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}

export default PortalEsqueciSenha;
